import { OverlayLifecycle } from './overlay-lifecycle.js';
class SiteHeader extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.dialog = this.querySelector('[data-menu-dialog]');
    this.openButton = this.querySelector('[data-open-menu]');
    this.closeButton = this.querySelector('[data-close-menu]');
    this.openButton?.addEventListener('click', () => this.open(), { signal: this.controller.signal });
    this.overlay = new OverlayLifecycle(this.dialog, { focus: () => this.closeButton, motion: false });
    this.closeButton?.addEventListener('click', () => this.overlay.close(), { signal: this.controller.signal });
    // Only the bar is sticky [9]; sticky consumers offset by its measured height.
    this.bar = this.querySelector('[data-site-header]');
    const measured = this.bar || this;
    this.syncHeight = () => document.documentElement.style.setProperty('--header-stack-height', `${measured.getBoundingClientRect().height}px`);
    this.layout = this.querySelector('[data-header-layout]');
    this.brand = this.layout?.querySelector('[data-header-brand]');
    this.resizeObserver?.disconnect();
    this.resizeObserver = new window.ResizeObserver(() => { this.syncHeight(); this.syncBrand(); });
    this.resizeObserver.observe(measured);
    for (const child of this.layout?.children || []) this.resizeObserver.observe(child);
    this.syncHeight();
    this.syncBrand();
    // The bar gains its hairline once the page scrolls under it.
    let frame = 0;
    const syncScrolled = () => { frame = 0; this.bar?.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', () => { if (!frame) frame = window.requestAnimationFrame(syncScrolled); }, { passive: true, signal: this.controller.signal });
    syncScrolled();
  }

  // The wordmark centers on the viewport while it clears both side groups by the bar's column gap;
  // otherwise it centers between them (owner, 18 Oct 2026). The groups keep their content width in
  // both layouts, so the choice never flips back and forth.
  syncBrand() {
    const layout = this.layout;
    const brand = this.brand;
    if (!layout || !brand) return;
    const style = window.getComputedStyle(layout);
    const box = layout.getBoundingClientRect();
    const start = box.left + Number.parseFloat(style.paddingLeft);
    const end = box.right - Number.parseFloat(style.paddingRight);
    let leftEdge = start;
    let rightEdge = end;
    for (const child of layout.children) {
      const rect = child.getBoundingClientRect();
      if (child === brand || !rect.width) continue;
      if (child.compareDocumentPosition(brand) & Node.DOCUMENT_POSITION_FOLLOWING) leftEdge = Math.max(leftEdge, rect.right);
      else rightEdge = Math.min(rightEdge, rect.left);
    }
    const reach = brand.getBoundingClientRect().width / 2 + (Number.parseFloat(style.columnGap) || 0);
    const center = (start + end) / 2;
    const between = center - reach < leftEdge - 0.5 || center + reach > rightEdge + 0.5;
    if (layout.hasAttribute('data-brand-between') !== between) layout.toggleAttribute('data-brand-between', between);
  }

  open() {
    return this.overlay.open(this.openButton);
  }

  disconnectedCallback() {
    this.overlay?.dispose();
    this.bar = null;
    this.layout = null;
    this.brand = null;
    this.resizeObserver?.disconnect();
    this.controller?.abort();
  }
}

if (!customElements.get('fl-site-header')) customElements.define('fl-site-header', SiteHeader);
